/**
 * Editor Operations
 *
 * TypeScript implementation of editor toggle operations.
 * Replaces legacy functions: changeMezoIrany, szinkronizal.
 */

import type { Puzzle } from '../core/Puzzle';
import type { AppState } from '../state/AppState';
import { domToCellId } from '../events/CellEvents';

/** Context for editor operations */
export interface EditorOperationContext {
    puzzle: Puzzle;
    appState: AppState;
    onMenuUpdate: () => void;
    onSelectionChange: () => void;
}

/**
 * Toggle cell direction (Függőleges kijelölési irány)
 */
export function changeDirection(
    element: HTMLElement,
    ctx: EditorOperationContext,
): void {
    ctx.appState.isHorizontal = !ctx.appState.isHorizontal;

    // Trigger selection change to update highlighting
    ctx.onSelectionChange();
    ctx.onMenuUpdate();
    element.focus();
}

/**
 * Toggle sync editing (Szinkronizált szerkesztés)
 */
export function toggleSyncEditing(
    element: HTMLElement,
    ctx: EditorOperationContext,
): void {
    // Check if puzzle has multiple grids
    if (!ctx.appState.hasMultipleGrids) return;

    ctx.appState.syncEditing = !ctx.appState.syncEditing;

    // Update sync highlight indicator
    const syncIndicator = document.getElementById('aktivszinkronmezo');
    if (syncIndicator) {
        if (ctx.appState.syncEditing) {
            const cellId = domToCellId(element);
            if (cellId !== null) {
                const nextCell = ctx.puzzle.getNextCell(cellId);
                if (nextCell) {
                    const syncCellEl = document.getElementById(
                        `mezo-${nextCell.id}`,
                    );
                    if (syncCellEl) {
                        syncIndicator.style.left = `${syncCellEl.offsetLeft}px`;
                        syncIndicator.style.top = `${syncCellEl.offsetTop}px`;
                        syncIndicator.style.display = 'block';
                    }
                }
            }
        } else {
            syncIndicator.style.display = 'none';
        }
    }

    ctx.onMenuUpdate();
    element.focus();
}
